module.exports = __webpack_public_path__ + "static/img/1082_small.effa2f3.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/1082_small.png
// module id = MuXr
// module chunks = 1